import React from "react";
import { Link } from "react-router-dom";
import { Search } from "../../Table";
import DropDown from "../../../../Components/DropDown";
import { Filter, FileX } from "lucide-react";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";

const PageHeader = ({
  title,
  breadcrumbs,
  onSearch,
  addButtonLink,
  onRefresh,
  filter,
  onFilterChange,
  limit,
  onLimitChange,
  filterConfig = [],
  onDownload,
  defaultFilterOpen = false,
}) => {
  const renderFilterField = (field) => {
    const {
      key,
      label,
      type,
      value,
      options = [],
      searchable = false,
      placeholder = "",
      colClass = "col-md-6 col-lg-3 mb-3",
    } = field;

    const handleChange = (newValue) => {
      onFilterChange({
        ...filter,
        [key]: newValue,
      });
    };

    switch (type) {
      case "date":
        return (
          <div key={key} className={colClass || "col-md-6 col-lg-3 mb-3"}>
            <label className="form-label">{label}</label>
            <input
              type="date"
              className="form-control"
              value={value || ""}
              onChange={(e) => handleChange(e.target.value)}
              placeholder={placeholder || "Select Date"}
            />
          </div>
        );

      case "dropdown":
        return (
          <div key={key} className={colClass || "col-md-6 col-lg-3 mb-3"}>
            <label className="form-label">{label}</label>
            <div className="custom-dropdown">
              <Dropdown
                value={value || null}
                onChange={(e) => handleChange(e.value)}
                options={options}
                optionLabel="label"
                optionValue="value"
                showClear
                placeholder={placeholder || "Select Option"}
                filter={searchable}
                style={{ width: "100%" }}
              />
            </div>
          </div>
        );

      case "multiselect":
        return (
          <div key={key} className={colClass || "col-md-6 col-lg-3 mb-3"}>
            <label className="form-label">{label}</label>
            <div className="custom-multiselect">
              <MultiSelect
                value={Array.isArray(value) ? value : []}
                onChange={(e) => handleChange(e.value)}
                options={options}
                optionLabel="label"
                optionValue="value"
                showClear
                placeholder={placeholder || "Select Options"}
                filter
                showSelectAll
                style={{ width: "100%" }}
              />
            </div>
          </div>
        );

      case "text":
      default:
        return (
          <div key={key} className={colClass || "col-md-6 col-lg-3 mb-3"}>
            <label className="form-label">{label}</label>
            <input
              type="text"
              className="form-control"
              placeholder={placeholder || "Enter text..."}
              value={value || ""}
              onChange={(e) => handleChange(e.target.value)}
            />
          </div>
        );
    }
  };

  return (
    <>
      {/* Breadcrumb */}
      <div
        className="page-header mb-0 pb-3"
        style={{ backgroundColor: "var(--bg-light-clr)" }}
      >
        <div className="row">
          <div className="col-sm-12">
            <ul className="breadcrumb">
              {breadcrumbs?.map((item, index) => (
                <React.Fragment key={index}>
                  {item.link ? (
                    <li className="breadcrumb-item">
                      <Link to={item.link}>{item.label}</Link>
                    </li>
                  ) : (
                    <li className="breadcrumb-item active">{item.label}</li>
                  )}
                  {index < breadcrumbs.length - 1 && (
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right"></i>
                    </li>
                  )}
                </React.Fragment>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Page Table Header */}
      <div className="page-table-header pb-2 pt-3">
        <div className="row align-items-center">
          <div className="col">
            <div className="doctor-table-blk">
              <h3>{title}</h3>
              <div className="doctor-search-blk">
                <div className="top-nav-search table-search-blk">
                  <form>
                    <Search onSearch={onSearch} />
                    {/* eslint-disable jsx-a11y/anchor-is-valid */}
                    <a className="btn">
                      <img
                        src="/assets/img/icons/search-normal.svg"
                        alt="firm-searchBox"
                      />
                    </a>
                  </form>
                </div>
                <div className="add-group">
                  {addButtonLink && (
                    <Link
                      to={addButtonLink}
                      className="btn btn-primary add-pluss ms-2"
                      title="Add"
                    >
                      <img src="/assets/img/icons/plus.svg" alt="plus-icon" />
                    </Link>
                  )}
                  <button
                    type="button"
                    onClick={onRefresh}
                    className="btn btn-primary doctor-refresh ms-2"
                    title="Refresh"
                  >
                    <img src="/assets/img/icons/re-fresh.svg" alt="refresh" />
                  </button>
                  {filterConfig.length > 0 && (
                    <button
                      type="button"
                      className="btn btn-primary ms-2"
                      data-bs-toggle="collapse"
                      data-bs-target="#filterPanel"
                      aria-expanded={defaultFilterOpen ? "true" : "false"}
                      aria-controls="filterPanel"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Filter"
                    >
                      <Filter size={20} />
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="pageDropDown col-auto text-end float-end ms-auto download-grp justify-content-center gap-2">
            <div className="add-group">
              {onDownload && (
                <button
                  type="button"
                  onClick={onDownload}
                  style={{ height: "43px", width: "45px", marginTop: "3px" }}
                  className="btn btn-primary rounded-2 p-0 d-flex gap-2 justify-content-center align-items-center"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Download Excel"
                >
                  <FileX size={17} />
                </button>
              )}
            </div>
            <DropDown limit={limit} onLimitChange={onLimitChange} />
          </div>
        </div>
      </div>

      {/* Filter Panel */}
      {filterConfig.length > 0 && (
        <div
          className={`collapse ${defaultFilterOpen ? "show" : ""}`}
          id="filterPanel"
          data-bs-auto-close="false"
        >
          <div className="mb-3 p-3">
            <div className="row">
              {filterConfig.map((field) => renderFilterField(field))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PageHeader;
